document.querySelectorAll("product-card .variant-picker select").forEach(function(select) {
    select.addEventListener("change", function(e) {
        var value = e.target.value;
        var buyButtons = select.closest("product-card").querySelector("buy-buttons");

        if (buyButtons) {
            buyButtons.setAttribute("data-variant-id", value);
            window.Abra.render();
        }
    });
});